import React from 'react';

interface FormStylesProps {
  customCSS?: string;
}

export const FormStyles: React.FC<FormStylesProps> = ({ customCSS }) => {
  return (
    <>
      {/* Apply custom theme styles if available */}
      {customCSS && <style dangerouslySetInnerHTML={{ __html: customCSS }} />}
    </>
  );
};
